// extracted by mini-css-extract-plugin
export default {"page":"Pg-z","cartModal":"Qg-z","checkout":"Rg-z","placeholder":"Sg-z","account":"Tg-z"};